export const DICTATION_ACK_KEY = 'shiftready:dictation-ack';

let opener = null;

export const hasDictationAck = () => {
  try { return localStorage.getItem(DICTATION_ACK_KEY) === '1'; } catch { return false; }
};

export const registerDictationPrompt = (fn) => {
  opener = fn;
  return () => { if (opener === fn) opener = null; };
};

export function requestDictationConsent() {
  if (hasDictationAck()) return Promise.resolve(true);
  return new Promise((resolve) => (opener ? opener(resolve) : resolve(false)));
}
